// // src/Components/constants/permissions.js
// const PERMISSION_LABELS = {
//   view_Dashboard: "View Dashboard",

//   read_Category: "Read Category",
//   create_Category: "Create Category",
//   update_Category: "Update Category",
//   delete_Category: "Delete Category",

//   // read_SubCategory: "Read SubCategory",
//   // create_SubCategory: "Create SubCategory",
//   // update_SubCategory: "Update SubCategory",
//   // delete_SubCategory: "Delete SubCategory",

//   read_ProductCategory: "Read ProductCategory",
//   create_ProductCategory: "Create ProductCategory",
//   update_ProductCategory: "Update ProductCategory",
//   delete_ProductCategory: "Delete ProductCategory",

//   read_Product: "Read Product",
//   create_Product: "Create Product",
//   update_Product: "Update Product",
//   delete_Product: "Delete Product",

//   read_Country: "Read Country",
//   create_Country: "Create Country",
//   update_Country: "Update Country",
//   delete_Country: "Delete Country",

//   read_State: "Read State",
//   create_State: "Create State",
//   update_State: "Update State",
//   delete_State: "Delete State",

//   read_City: "Read City",
//   create_City: "Create City",
//   update_City: "Update City",
//   delete_City: "Delete City",

//   read_VariantName: "Read VariantName",
//   create_VariantName: "Create VariantName",
//   update_VariantName: "Update VariantName",
//   delete_VariantName: "Delete VariantName",

//   read_VariantValue: "Read VariantValue",
//   create_VariantValue: "Create VariantValue",
//   update_VariantValue: "Update VariantValue",
//   delete_VariantValue: "Delete VariantValue",

//   read_User: "Read User",
//   create_User: "Create User",
//   update_User: "Update User",
//   delete_User: "Delete User",

//   read_RoleAccessControl: "Read Role Access Control",
//   create_RoleAccessControl: "Create Role Access Control",
//   update_RoleAccessControl: "Update Role Access Control",
//   delete_RoleAccessControl: "Delete Role Access Control",

//   read_GeneralMaster: "Read General Master",

//   update_CompanySettings: "Update Company Settings",
// };
// export default PERMISSION_LABELS;

const MODULE_PERMISSIONS = {
  Dashboard: ['view'],
  Category: ['read', 'create', 'update', 'delete'],
  // SubCategory: ['read', 'create', 'update', 'delete'],
  // ProductCategory: ['read', 'create', 'update', 'delete'],
  Product: ['read', 'create', 'update', 'delete'],
  Country: ['read', 'create', 'update', 'delete'],
  State: ['read', 'create', 'update', 'delete'],
  City: ['read', 'create', 'update', 'delete'],
  VariantName: ['read', 'create', 'update', 'delete'],
  VariantValue: ['read', 'create', 'update', 'delete'],
  User: ['read', 'create', 'update', 'delete'],
  RoleAccessControl: ['read', 'create', 'update', 'delete'],
  Message: ['read', 'create', 'update', 'delete'],
  CompanySettings: ['read','update'],
  Order :['read', 'create', 'update', 'delete'],
  Banner :['read', 'create', 'update', 'delete'],
};


const FLAT_PERMISSIONS = Object.entries(MODULE_PERMISSIONS).flatMap(([module, actions]) =>
  actions.map(action => `${action}_${module}`)
);

export { MODULE_PERMISSIONS, FLAT_PERMISSIONS };
export default MODULE_PERMISSIONS;
